export enum AppRoutes {
  CREATE_APPOINTMENT = "/create-appointment",
  CREATE_APPOINTMENT_ORDER_COMPLETE = "/create-appointment/order-complete",
  CREATE_APPOINTMENT_SCHEDULE = "/create-appointment/schedule",
  SCHEDULE_OL_APPOINTMENT = "/schedule-ol-appointment",
  SELF_SERVE_MIGRATION = "/self-serve-migration",
  WHAT_YOU_NEED_TO_COMPLETE = "/what-you-need-to-complete",
}
